import * as Types from 'src/actions/user/requiredProfile/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import User from 'src/entities/User';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CheckRequiredProfileAttempt extends Action {
  type: Types.CHECK_REQUIRED_PROFILE_ATTEMPT;
}

export interface CheckRequiredProfileSuccess extends Action {
  type: Types.CHECK_REQUIRED_PROFILE_SUCCESS;
  payload: User;
}

export interface CheckRequiredProfileFailure extends Action {
  type: Types.CHECK_REQUIRED_PROFILE_FAILURE;
  payload: {};
}

export interface CheckRequiredProfileClear extends Action {
  type: Types.CHECK_REQUIRED_PROFILE_CLEAR;
}

export type CheckRequiredProfileAction = CheckRequiredProfileAttempt | CheckRequiredProfileSuccess |
  CheckRequiredProfileFailure | CheckRequiredProfileClear;

export interface CheckRequiredProfileThunk extends ThunkAction<Promise<CheckRequiredProfileAction>, RootState, null> {
}

export const checkRequiredProfileAttempt: ActionCreator<CheckRequiredProfileAttempt> = () => (
  { type: Types.CHECK_REQUIRED_PROFILE_ATTEMPT }
);

export const checkRequiredProfileSuccess: ActionCreator<CheckRequiredProfileSuccess> = (user: User) => (
  {
    type: Types.CHECK_REQUIRED_PROFILE_SUCCESS,
    payload: user
  }
);

export const checkRequiredProfileFailure: ActionCreator<CheckRequiredProfileFailure> = (error: {}) => (
  {
    type: Types.CHECK_REQUIRED_PROFILE_FAILURE,
    payload: error
  }
);

export const checkRequiredProfileClear: ActionCreator<CheckRequiredProfileClear> = () => (
  { type: Types.CHECK_REQUIRED_PROFILE_CLEAR }
);

export const checkRequiredProfile: ActionCreator<CheckRequiredProfileThunk> = (
  personId: number,
  personType: string
): CheckRequiredProfileThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CheckRequiredProfileAction> => {
    dispatch(checkRequiredProfileAttempt());

    return ApiClient.checkUserProfile.get(personId, {personType: personType})
      .then((response: AxiosResponse<User>): CheckRequiredProfileSuccess => {

        return dispatch(checkRequiredProfileSuccess());
      }).catch((response: AxiosResponse): CheckRequiredProfileFailure => {
        const errors = ValidatorService.translateValidations(JSON.parse(response.request.response).errors);

        return dispatch(checkRequiredProfileFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/user/requiredProfile/CheckRequiredProfile.actions.tsx